import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryBoarding extends FDictionary {
  dictionary = 'boarding';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init().then();
    return item;
  }
}
